import script from "./OnlineOrdersView.vue?vue&type=script&setup=true&lang=js"
export * from "./OnlineOrdersView.vue?vue&type=script&setup=true&lang=js"

import "./OnlineOrdersView.vue?vue&type=style&index=0&id=3741581e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3741581e"]])

export default __exports__